import { useWatch } from 'react-hook-form';

import { createInterpolatedTranslationKey, Translate } from '@dreryk/react-common';

import { visitDetailsTranslationKeys } from '../../../../translations';
import { VisitFormController } from '../../visitForm.types';

import { ProcedureTableBean } from './procedures.types';

type ProceduresFormTabLabelProps = {
   readonly control: VisitFormController['control'];
};

export const ProceduresFormTabLabel = (props: ProceduresFormTabLabelProps): JSX.Element => {
   const { length: count } = useWatch<ProcedureTableBean[]>({
      name: 'procedures.value',
      control: props.control,
      defaultValue: [],
   });

   return (
      <Translate>
         {createInterpolatedTranslationKey(visitDetailsTranslationKeys.procedures.procedures, {
            count: count,
         })}
      </Translate>
   );
};
